import { Bug } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useDebug } from "@/contexts/DebugContext";
import { cn } from "@/lib/utils";

export const DebugToggle = () => {
  const { isDebugEnabled, toggleDebug } = useDebug();

  return (
    <Button
      variant={isDebugEnabled ? "default" : "ghost"}
      size="sm"
      onClick={toggleDebug}
      className={cn(
        "transition-all",
        isDebugEnabled && "bg-primary text-primary-foreground animate-pulse ring-2 ring-primary/50"
      )}
      title={isDebugEnabled ? "Désactiver les logs console" : "Activer les logs console"}
    >
      <Bug className="h-4 w-4" />
    </Button>
  );
};
